// The landing composer stages files locally because no project/run id exists yet.
export const PROJECTS_COMPOSER_MAX_STAGED_FILES = 20;
